import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Allpagesbanners from '../components/Allpagesbanners';

function Clients_Zone() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleInvalid = (e) => {
    e.preventDefault();
    console.warn('Invalid field:', e.target.name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const res = await fetch('http://jbytam.com/Clients_mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData) // ✅ Properly encoded JSON
      });

      const result = await res.json();

      if (result.status === 'success') {
        alert('Message sent successfully!');
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          service: '',
          message: ''
        });
      } else {
        alert('Error: ' + result.message);
      }
    } catch (error) {
      alert('Failed to send message. Please try again.');
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Header />
      <Allpagesbanners />
      <div className="contact-inner-area sp1">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="heading1">
                <h5>Contact Us</h5>
                <div className="space32"></div>
                <h2>Let’s Work Together To Achieve Your Goals</h2>
                <p>At JBY Talent Acquisition & Management Private Limited, we connect talented individuals with outstanding job opportunities.</p>
                <p>Contact us via phone or email — we look forward to making your staffing experience successful.</p>
                <ul className="contact-social">
                  <li><a href="https://www.facebook.com/people/Jby-Talent-Acquisition-Management/61575552617015/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                  <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                  <li><a href="https://www.instagram.com/jbytam_2025/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              <form className="contact-main-boxarea" onSubmit={handleSubmit} noValidate onInvalid={handleInvalid}>
                <h3>Send Message</h3>
                <p>We’ll get back to you at the earliest during business hours.</p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-area">
                      <input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-area">
                      <input
                        type="text"
                        name="lastName"
                        placeholder="Company Name"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-area">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-area">
                      <input
                        type="text"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-area">
                      <select name="service" value={formData.service} onChange={handleChange} required>
                        <option value="">Select Service</option>
                        <option value="Employee Training">Employee Training</option>
                        <option value="Manpower Sourcing">Manpower Sourcing</option>
                        <option value="Corporate Grooming Programs">Corporate Grooming Programs</option>
                        <option value="Performance Management">Performance Management</option>
                        <option value="KRAs & KPIs">KRAs & KPIs</option>
                        <option value="Company Policy Development">Company Policy Development</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-area">
                      <textarea
                        name="message"
                        placeholder="How can we help you?"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-12 text-end">
                    <button type="submit" className="vl-btn1" disabled={isSubmitting}>
                      {isSubmitting ? 'Sending...' : 'Send Now'} <i className="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="contact-maps-area">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d9494.414235982638!2d72.8256808345173!3d19.20127960425157!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sjbytam%20Nilkanth%20Nagar%2C%20Kandivali%20West!5e0!3m2!1sen!2sin!4v1754569992230!5m2!1sen!2sin"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Maps"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Clients_Zone;
